export const POSTHOG_FEATURE_FLAGS = {
  ENABLE_AUTOCAPTURE: 'ENABLE_AUTOCAPTURE',
};
